import * as React from 'react';
import { useState } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import { Box, Dialog } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function RegisterStep1(props) {
  const { disableButton, handleRegisterValues, handleRegisterStep1Submit, handleShowingFormsValues, registerValues, customToastify } = props
  const handleClickSubmit = (e) => {
    if (registerValues["phoneNumber"].length == 0) customToastify("error", "لطفا شماره تلفن همراه را وارد کنید")
    else handleRegisterStep1Submit()
  }
  const gmailClick = () => {
    handleShowingFormsValues("GmailPopUp")
  }

  return (
    <Box
      sx={{
        marginTop: 0.5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Avatar sx={{ m: 0.5, bgcolor: 'secondary.main' }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5" >
        ثبت نام در سایت
      </Typography>
      <Box noValidate sx={{ mt: 1 }}>
        <PhoneInput
          isValid={(value, country) => {
            if (value.match(/12345/)) {
              return "شماره نامعتبر";
            } else if (value.match(/1234/)) {
              return false;
            } else {
              return true;
            }
          }}
          placeholder="شماره تلفن"
          countryCodeEditable={false}
          inputStyle={{ color: 'black', width: "220px" }}
          containerStyle={{ color: 'black', direction: "ltr" }}
          buttonStyle={{}}
          //   dropdownStyle={{height:'50px'}}
          country={'ir'}
          enableSearch={true}
          onChange={(phone, country) => {
            handleRegisterValues("phoneNumberAndcountryName", [phone, country["name"]]);
          }}
        />
        <Button
          disabled={disableButton}
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 1, mb: 1 }}
          onClick={handleClickSubmit}
        >
          ادامه
        </Button>
        <Grid container>
          <Container maxWidth="sx"  >
            <Link href="#" onClick={gmailClick} variant="body1">
              {"ثبت نام با Gmail"}
            </Link>
          </Container >
          <Container maxWidth="sx"  >
            <Link href="#" onClick={() => { handleShowingFormsValues("FormalLogin") }} variant="body2">
              {"قبلا ثبت نام کرده ام!"}
            </Link>
          </Container >
          <Container maxWidth="sx" >
            <Link href="#" onClick={() => { handleShowingFormsValues("RegisterStep2") }} variant="caption">
              {"کد را دریافت کرده ام ( ادامه)"}
            </Link>
          </Container >
        </Grid>
      </Box>
    </Box>
  )
}